// flow
// globals window
import configLocalJson from './local.json';
import configDevJson from './dev.json';
import configStageJson from './stage.json';
import configProdJson from './production.json';
import { getLogger } from '../utils/SearchLogger';

if (typeof window === 'undefined') {
	// @ts-ignore
	globalThis.window = {};
}

function getConfig(env: string, key: string): string {
	if (!globalThis.SEARCH_CONFIG) {
		switch (env) {
			case 'local':
				globalThis.SEARCH_CONFIG = configLocalJson;
				break;

			case 'dev':
				globalThis.SEARCH_CONFIG = configDevJson;
				break;

			case 'stage':
				globalThis.SEARCH_CONFIG = configStageJson;
				break;

			case 'prod':
				globalThis.SEARCH_CONFIG = configProdJson;
				break;

			default:
				globalThis.SEARCH_CONFIG = configProdJson;
				getLogger().warn('index.js', "Didn't find window.ENV, setting window.ENV to prod", env);
				break;
		}
	}

	return globalThis.SEARCH_CONFIG[key];
}

getConfig.config = globalThis.SEARCH_CONFIG;
getConfig.json = JSON.stringify(globalThis.SEARCH_CONFIG);
export default getConfig;
